import { useSitecoreContext } from './useSitecoreContext';

export function useContentItem() {
  const { sitecoreContext } = useSitecoreContext();
  return sitecoreContext?.contentItem;
}
